import { render, staticRenderFns } from "./StarredNews.vue?vue&type=template&id=5098f316&"
import script from "./StarredNews.vue?vue&type=script&lang=js&"
export * from "./StarredNews.vue?vue&type=script&lang=js&"
import style0 from "./StarredNews.vue?vue&type=style&index=0&id=5098f316&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports